<template>
  <div>
    <div class="ml-l pl-l mb-l pb-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <el-form :disabled="$route.query.type === 'edit'" :model="form" label-position="left" label-width="80px" ref="form" size="small">
      <div class="container">
        <h3 class="title">新建优惠券模版</h3>

        <el-form-item label="名称">
          <el-col span="8">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="面值类型">
          <el-row>
            <el-col span="2">
              <el-radio :label="1" v-model="form.amountkind">指定金额</el-radio>
            </el-col>
            <el-col span="4" v-show="form.amountkind == '1'">
              <el-input placeholder="请输入面值" v-model="form.amount">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="2">
              <el-radio :label="0" v-model="form.amountkind">随机金额</el-radio>
            </el-col>
            <template v-if="form.amountkind == '0'">
              <el-col span="4">
                <el-input placeholder="请输入最小面值" v-model="form.amountbegin">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-col>
              <el-col span="1" style="text-align: center;">-</el-col>
              <el-col span="4">
                <el-input placeholder="请输入最大面值" v-model="form.amountend">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-col>
            </template>
          </el-row>
        </el-form-item>

        <el-form-item label="有效时间">
          <el-row>
            <el-col span="2">
              <el-radio :label="0" v-model="form.timekind">不限制</el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="2">
              <el-radio :label="2" v-model="form.timekind">量化时间</el-radio>
            </el-col>
            <template v-if="form.timekind == '2'">
              <el-col span="4">
                <el-input placeholder="请输入有效天数" v-model="form.duration"></el-input>
              </el-col>
              <el-col span="10" style="color: #999; margin-left: 10px;">例如有效时常30天，则在发布或领取后30天失效</el-col>
            </template>
          </el-row>
        </el-form-item>

        <el-form-item class="form-item-reach-type" label="使用门槛">
          <el-row>
            <el-col span="4">
              <el-radio :label="0" v-model="reachType">
                满
                <el-input style="width: 100px;" v-model="form.reach">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
                <span style="margin-left: 5px;">可用</span>
              </el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="1" v-model="reachType">不限制</el-radio>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="适用商品">
          <el-row>
            <el-col span="4">
              <el-radio :label="0" v-model="form.producttype">可用于所有商品</el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="1" v-model="form.producttype">可用于部分商品</el-radio>
            </el-col>
            <template v-if="form.producttype == '1'">
              <el-col class="product-select" span="9">
                <el-select :loading="fetchProductLoading" :remote-method="getProducts" filterable multiple placeholder="选择商品" remote v-model="form.productidsList" style="width: 100%;">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="2" v-model="form.producttype">不可用于部分商品</el-radio>
            </el-col>
            <template v-if="form.producttype == '2'">
              <el-col span="4">
                <el-select :loading="fetchProductLoading" :remote-method="getProducts" filterable multiple placeholder="选择商品" remote v-model="form.productidsList">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
        </el-form-item>
      </div>
      <div class="container conponedit-button">
        <el-button @click="onSubmit" type="primary">创建</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
export default {
  data() {
    return {
      form: {
        name: '',
        reach: '',
        timekind: 0,
        duration: '',
        categorytype: 0,
        categoryidsList: [],
        producttype: 0,
        productidsList: [],
        amountkind: 1,
        amountbegin: '',
        amountend: '',
        amount: ''
      },
      reachType: 0,
      categories: [],
      products: [],
      fetchProductLoading: false
    };
  },
  created() {
    this.token = getToken();
    rpc(
      'StoreCategoryService.GetCategoryList',
      M('CategoryListQueryRequest', {
        token: M('Token', { token: this.token }),
        ishidden: 2,
        level: 2,
        count: 100,
        sortby: 1
      })
    ).then(res => {
      this.categories = res.categorylistList;
    });
  },

  methods: {
    getProducts(name) {
      if (!name) return (this.products = []);
      this.fetchProductLoading = true;
      rpc(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: this.token }),
          name,
          isonline: 1,
          sortby: 1,
          sort: 1,
          count: 100
        })
      ).then(res => {
        this.products = res.productlistList;
        this.fetchProductLoading = false;
      });
    },

    onSubmit() {
      const opt = JSON.parse(JSON.stringify(this.form));
      opt.amountbegin = this.$amount2(this.form.amountbegin);
      opt.amountend = this.$amount2(this.form.amountend);
      opt.amount = this.$amount2(this.form.amount);
      opt.reach = this.$amount2(this.form.reach);
      if (this.reachType == 1) {
        opt.reach = 0;
      }
      opt.duration = parseInt(opt.duration * 60 * 60 * 24);
      rpc(
        'StoreCouponTemplateService.CreateCouponTemplate',
        M('CouponTemplateWithTokenRequest', {
          token: M('Token', { token: this.token }),
          coupontemplate: M('CouponTemplate', opt)
        })
      ).then(res => {
        this.$router.back();
      });
    }
  }
};
</script>

<style>
.conponedit-button {
  display: flex;
}
.form-item-reach-type .el-input-group__append {
  padding: 0 5px;
}
.product-select .el-select .el-tag {
  padding-right: 8px;
}
.product-select .el-select__tags-text {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 3px;
}
</style>
